import React from 'react'
import {
  makeStyles,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link,
  Typography,
} from "@material-ui/core"
import PersonIcon from '@material-ui/icons/Person';
import DescriptionIcon from '@material-ui/icons/Description';
import EditIcon from '@material-ui/icons/Edit';
import { history } from "../../helpers";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { useLocation, useHistory} from "react-router-dom";
import { Copyright } from '../Shared';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  sidebarIcon: {
    minWidth: "auto",
    paddingRight: 8,
  },
  sidebarText: {
    fontWeight: 600,
    fontSize: 15
  }
}));

export const SidebarManageAccess = () => {
  const classes = useStyles();
  const location = useLocation();
  const { selectedUser } = useSelector(state => state.userFunction)
  const { typeProfile } = useSelector(state => state.user)
  const { t } = useTranslation();
  return (
    <List>
      { selectedUser?.id !== undefined ? (<ListItem button onClick={() => history.replace(`/users/function/${selectedUser?.id}`)}>
        <ListItemIcon className={classes.sidebarIcon}>
          <DescriptionIcon color={location.pathname.split("/")[2] === "function" ? 'primary' : 'inherit'}/>
        </ListItemIcon>
        <ListItemText 
          primary={<Typography color={location.pathname.split("/")[2] === "function" ? 'primary' : 'inherit'} 
          className={classes.sidebarText}
        >
          {t('atribuir_funcao_ao_usuario')}
        </Typography>} />
      </ListItem>) : <Skeleton height={50} width={300} />}

      { typeProfile.type === "admin" && selectedUser?.id !== undefined ? (
        <ListItem button onClick={() => history.replace(`/users/edit/${selectedUser?.id}`)}>
          <ListItemIcon className={classes.sidebarIcon}>
            <EditIcon color={location.pathname.split("/")[2] === "edit" ? 'primary' : 'inherit'} />
          </ListItemIcon>
          <ListItemText 
            primary={<Typography color={location.pathname.split("/")[2] === "edit" ? 'primary' : 'inherit'} 
            className={classes.sidebarText}
          >
            {t('editar_dados_do_usuario')}
          </Typography>} />
        </ListItem>
      ) : <Skeleton height={50} width={300} />}
      { typeProfile.type === "admin" && selectedUser?.id !== undefined ? (
        <ListItem button onClick={() => history.replace(`/users/points/${selectedUser?.id}`)}>
          <ListItemIcon className={classes.sidebarIcon}>
            <AccountBalanceWalletIcon color={location.pathname.split("/")[2] === "points" ? 'primary' : 'inherit'} />
          </ListItemIcon>
          <ListItemText 
            primary={<Typography color={location.pathname.split("/")[2] === "points" ? 'primary' : 'inherit'} 
            className={classes.sidebarText}
          >
            {t('gerenciar_pontos')}
          </Typography>} />
        </ListItem>
      ): <Skeleton height={50} width={300} />}
      <Copyright />
    </List>
  )
}
